import { Helmet } from "react-helmet"

import Layout from "../components/layout/Layout"
import Brand1 from "../components/sections/Brand1"
import ProjectDetails from "../components/sections/ProjectDetails"
export default function ProjectDetailsPage() {
	return (
		<>
			<Helmet>
				<title>V-Make | Sustainability</title>
				<meta name="description" content="At V-Make, sustainability is at the heart of everything we do. Our WPC doors, frames, and boards are made with eco-conscious practices, ensuring long-lasting and environmentally responsible solutions." />
				<meta name="keywords" content="sustainable WPC products, eco-friendly doors, green construction materials, recyclable WPC boards, environmentally friendly doors, V-Make sustainability, WPC environmental impact" />
				<link rel="canonical" href="https://vmakewpc.com/Sustainability" />
				<meta property="og:title" content="V-Make | Sustainability" />
				<meta property="og:description" content="Learn how V-Make champions sustainability with innovative, eco-conscious WPC products for modern construction." />
				<meta property="og:url" content="https://vmakewpc.com/Sustainability" />
				<meta
					property="og:image"
					content="	https://vmakewpc.com/assets/img/project/Sus_6.gif" // Replace with actual image path
				/>
			</Helmet>
			<Layout headerStyle={1} footerStyle={1} >
				<ProjectDetails />
				{/* <Brand1 /> */}
			</Layout>
		</>
	)
}
